import React from 'react'
import SarasAMCStatus from '../../repeater/keyvalue/SarasAMCStatus';
import * as fn from '../../../helper/uiFunctions';

const FormAMCStatus = (props) => {
    const { formObject, action, rowKey, headerKey } = props

    let viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const activeCount = formObject.getValueFromKey(viewData, "val", '0');
    const recentCount = formObject.getValueFromKey(viewData, "dataList.recent", '0');
    const oldCount = formObject.getValueFromKey(viewData, "dataList.old", '0');
    const criteria = formObject.getValueFromKey(viewData, "dataList.criteria", '');

    const statusItems = [
        { label: "Active", value: activeCount, classKey: "Active" },
        { label: "Recent", value: recentCount, classKey: "Recent" },
        { label: "Old", value: oldCount, classKey: "Old" }
    ];

    const amcUrl = fn.getSearchDocumentLink(703, null, null, 1, `initialCriteria=${encodeURIComponent(criteria)}`);

    return (
        <SarasAMCStatus hide={hide} labelValuePair={statusItems} miniVersion={false} url={amcUrl}/>
    )
}

export default FormAMCStatus
